import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.COLUMNSPLAN,
      "data-source": _vm.tableData,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (text, record) {
        return [_c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "releasePlanHomeInfo",
                params: {
                  id: record.id
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看")))]), _c("a-button", {
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handlePremiumTemplate(record);
            }
          }
        }, [_vm._v("配置保费模版")])];
      }
    }])
  }, [_vm._l(_vm.COLUMNSPLAN, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), _c("template", {
    slot: "保费"
  }, [_vm._v(" (" + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false))) + ") ")])], 2), _vm.premiumTemplateShow ? _c("premium-template-model", {
    ref: "premiumTemplateRef",
    on: {
      cancel: function ($event) {
        _vm.premiumTemplateShow = false;
      }
    }
  }) : _vm._e(), _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    staticClass: "marginR15",
    on: {
      click: function ($event) {
        return _vm.$emit("previous");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.$router.push({
          name: "productManage"
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("返回")))])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };